var QMegaMenu=class extends HTMLElement{constructor(){super();this.init()}
init(){let leftList=this.querySelectorAll(".qm-left-items")
let rightList=this.querySelectorAll(".qm-right")
let gridList=this.querySelectorAll(".qm-prod-grid")
let oUl=this.querySelector(".qm-left-item-wrap")
let timer=null
leftList.forEach((item,i)=>{let fn=()=>{leftList.forEach((item,i)=>{item.setAttribute("show","")})
item.setAttribute("show","1")
rightList.forEach((r,j)=>{r.setAttribute("show","")
gridList[j].setAttribute("show","")})
rightList[i].setAttribute("show","1")
setTimeout(()=>{gridList[i].setAttribute("show","1")},10)}
item.addEventListener("mouseenter",()=>{clearTimeout(timer)
timer=setTimeout(()=>{fn()},150)})})
oUl.addEventListener("mouseleave",()=>{clearTimeout(timer)})
let oMoreBtn=this.querySelectorAll(".qm-more-pro-btn")
let oOneRows=this.querySelectorAll(".qm-right-one-row")
oMoreBtn.forEach((item,i)=>{item.addEventListener("click",()=>{let show=oOneRows[i].getAttribute("show")
if(show==='1'){oOneRows[i].setAttribute("show","")
item.setAttribute("show","")}else{oOneRows[i].setAttribute("show","1")
item.setAttribute("show","1")}})})}};if(!window.customElements.get("q-mega-menu")){window.customElements.define("q-mega-menu",QMegaMenu)}
var QMDAccordion=class extends HTMLElement{constructor(){super();this.init()}
init(){let oTabs=this.querySelectorAll(".qmd-cate")
let oContents=this.querySelectorAll(".qmd-acco-item")
oTabs.forEach((item,i)=>{item.addEventListener("click",()=>{let show=oContents[i].getAttribute("show")
if(show==='1'){oContents[i].setAttribute("show","")}else{oContents.forEach((item,i)=>{item.setAttribute("show","")})
oContents[i].setAttribute("show","1")}})})}};if(!window.customElements.get("q-qmd-accordion")){window.customElements.define("q-qmd-accordion",QMDAccordion)}
export{QMegaMenu,QMDAccordion}